import { NumberFormatter } from '@mantine/core';
import cx from 'clsx';

import { trendIcons } from '../constants.tsx';
import classes from '../Kpi.module.css';

export interface StandardKpiProps {
  /** Number (formatted by NumberFormatter) or any pre-formatted ReactNode. */
  value?: React.ReactNode;
  label?: React.ReactNode;
  unit?: string;
  trend?: keyof typeof trendIcons;
  trendValue?: number;
  decimalScale?: number;
}

/**
 * Standard KPI rendering - bordered card with optional trend indicator.
 */
export function StandardKpi({ value, label, unit, trend, trendValue, decimalScale = 2 }: StandardKpiProps) {
  const trendIcon = trend ? trendIcons[trend] : null;

  const formattedValue =
    typeof value === 'number' ? <NumberFormatter decimalScale={decimalScale} thousandSeparator value={value} /> : value;

  return (
    <div className={classes.kpi}>
      <div className={classes.valueRow}>
        <span className={classes.value}>{formattedValue}</span>
        {unit && <span className={classes.unit}>{unit}</span>}
      </div>
      <span className={classes.label}>{label}</span>
      {(trendIcon ?? trendValue !== undefined) && (
        <div className={classes.trendRow}>
          {trendIcon}
          {trendValue !== undefined && (
            <span
              className={cx(
                classes.trendValue,
                trend === 'up' && classes.trendUp,
                trend === 'down' && classes.trendDown,
                trend === 'neutral' && classes.trendNeutral,
              )}
            >
              {trendValue > 0 ? '+' : ''}
              <NumberFormatter decimalScale={1} suffix="%" value={trendValue} />
            </span>
          )}
        </div>
      )}
    </div>
  );
}
